import { REQUEST_TOKEN_STATUS, IS_REQUESTING_TOKEN } from './lightspeedTypes';
import api from '../../api';
import { createAlert } from '../Alert/actions';

export function getLightspeedStatus() {
  return function (dispatch) {
    dispatch({ type: IS_REQUESTING_TOKEN, payload: true });
    return api
      .get(`/integration/lightspeed/status`)
      .then((response) => {
        dispatch({
          type: REQUEST_TOKEN_STATUS,
          payload: response?.data?.data?.is_valid || false,
        });
        dispatch({ type: IS_REQUESTING_TOKEN, payload: false });
      })
      .catch((error) => {
        dispatch(
          createAlert({
            type: 'error',
            message:
              error?.response?.data?.errors?.message ||
              'An error occurred trying to delete tag',
          })
        );
      })
      .finally(() => {
        dispatch({ type: IS_REQUESTING_TOKEN, payload: false });
      });
  };
}

export function getLightspeedLink() {
  return function (dispatch) {
    dispatch({ type: IS_REQUESTING_TOKEN, payload: true });
    return api
      .get(`/integration/lightspeed/token-url`)
      .then((response) => {
        console.log('response', response.data);
        if (response?.data?.data?.token_url) {
          window.open(response.data.data.token_url, '_self');
        }
        dispatch({ type: IS_REQUESTING_TOKEN, payload: false });
      })
      .catch((error) => {
        dispatch(
          createAlert({
            type: 'error',
            message:
              error?.response?.data?.errors?.message ||
              'An error occurred trying to delete tag',
          })
        );
      })
      .finally(() => {
        dispatch({ type: IS_REQUESTING_TOKEN, payload: false });
      });
  };
}
export function requestLightspeedToken(code) {
  return function (dispatch) {
    dispatch({ type: IS_REQUESTING_TOKEN, payload: true });
    return api
      .post(`/integration/lightspeed/request-token`, { code })
      .then((response) => {
        dispatch({ type: REQUEST_TOKEN_STATUS, payload: true });
        dispatch({ type: IS_REQUESTING_TOKEN, payload: false });
      })
      .catch((error) => {
        dispatch(
          createAlert({
            type: 'error',
            message:
              error?.response?.data?.errors?.message ||
              'An error occurred trying to delete tag',
          })
        );
      })
      .finally(() => {
        dispatch({ type: IS_REQUESTING_TOKEN, payload: false });
      });
  };
}
